<template>
  <div class="dashboard-view">
    <!-- 顶部查询 -->
    <header-bar v-model="queryForm" @handleQuery="handleQuery"></header-bar>
    <!-- 汇总信息展示 -->
    <stat-cards :key="queryKey"></stat-cards>
    <!-- 根据展示类型切换显示 -->
    <tabs-container v-model="activeTab" :key="queryKey" ref="tabsContainer"></tabs-container>
  </div>
</template>

<script>
import HeaderBar from './components/HeaderBar.vue'
import StatCards from './components/StatCards.vue'
import TabsContainer from './components/TabsContainer.vue'

export default {
  components: {
    HeaderBar,
    StatCards,
    TabsContainer,
  },
  provide () {
    return {
      parentThat: this,
    }
  },
  data () {
    return {
      queryForm: {},
      activeTab: 'workHourAnalysis',
      queryKey: true,
    }
  },
  created () {},
  methods: {
    handleQuery () {
      console.log(this.activeTab, '888');
      const copyActiveTab = this.activeTab
      this.queryKey = !this.queryKey
      this.activeTab = copyActiveTab

      console.log(copyActiveTab, '66', this.activeTab);
    }
  }
}
</script>

<style scoped>
.dashboard-view {
  padding: 10px;
  background-color: #fff;
}
</style>